import { ClipboardEvent, RefObject } from 'react'
import { debounce } from 'lodash'

import { DEBOUNCE_SEARCH_TIME_LIMIT } from 'lib/participants/Constants'
import { SEARCH_WORD_LIMIT } from 'types/TextAnalysis'

export type ClipboardEventInput = ClipboardEvent<HTMLInputElement>

const debounceSearch = debounce((value, onSearch, setClearable) => {
  onSearch(value)
  setClearable(value ? true : false)
}, DEBOUNCE_SEARCH_TIME_LIMIT)

export const handlePaste = (e: ClipboardEventInput) => {
  const pastedText = e.clipboardData.getData('text')
  const pastedWords = pastedText.split(/\s+/)

  // Prevent pasting if the number of words exceeds the limit
  if (pastedWords.length > SEARCH_WORD_LIMIT) e.preventDefault()
}

export const handleInputChange = (
  inputValue: string,
  onSearch: (value: string) => void,
  setClearable: (value: boolean) => void,
) => {
  const words = inputValue.split(/\s+/)

  // Limit the number of words in the search input
  if (words.length <= SEARCH_WORD_LIMIT) {
    debounceSearch.cancel()
    debounceSearch(inputValue, onSearch, setClearable)
  }
}

export const clearSearch = (
  inputRef: RefObject<HTMLInputElement>,
  onSearch: (value: string) => void,
  setClearable: (value: boolean) => void,
) => {
  if (inputRef.current) {
    inputRef.current.value = ''
    onSearch('')
    setClearable(false)
  }
}
